import { Component, OnInit, Input } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ApprovedHousingSessionInformation, CampusWard, AcademicSession } from '../../models';
import { HousingDataService, SortService } from '../../services';

@Component({
  selector: 'app-ward-complexes',
  templateUrl: './ward-complexes.component.html',
  styleUrls: ['./ward-complexes.component.scss']
})
export class WardComplexesComponent implements OnInit {
  @Input() ward: CampusWard;

  academicSessions: AcademicSession[];
  selectedAcademicSession: AcademicSession;

  loadingHousing = false;
  housingError = false;
  housingData: ApprovedHousingSessionInformation[];

  constructor(private housingService: HousingDataService, private sorter: SortService) {}

  ngOnInit() {
    this.housingService.getAcademicSessions().subscribe(sessions => this.handleSessions(sessions));
  }

  /**
   * Loads the housing complexes and addresses that have been assigned to the ward for the selected semester.
   */
  loadHousingInformation() {
    if (this.ward && this.selectedAcademicSession && !this.loadingHousing) {
      this.housingData = null;
      this.loadingHousing = true;
      this.housingService
        .getHousingComplexSessionInformation(this.ward.campusWardId, this.selectedAcademicSession.sessionNumber)
        .pipe(
          finalize(() => (this.loadingHousing = false))
        )
        .subscribe(
          information => {
            this.housingData = information;
            this.housingData.sort(this.sorter.sortApprovedHousingSessionInformationAsc);
          },
          error => {
            this.housingError = true;
          }
        );
    }
  }

  /**
   * Handles the housing sessions.
   */
  private handleSessions(academicSessions: AcademicSession[]) {
    this.academicSessions = academicSessions;
    this.academicSessions.sort(this.sorter.sortAcademicSessionsAsc);
    if (academicSessions.length > 0) {
      this.selectedAcademicSession = this.academicSessions[0];
      this.loadHousingInformation();
    }
  }
}
